import { getLocalizedPath } from '../i18n/localizedRoutes';
import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';

const NotFoundPage = () => {
  const { t, locale } = useI18n();
  return (
    <main style={{ maxWidth: 760, margin: '0 auto', padding: '30px 16px', textAlign: 'center' }}>
      <Seo
        title={t('notFound.seoTitle')}
        description={t('notFound.seoDescription')}
        path={typeof window !== 'undefined' ? window.location.pathname : '/404'}
        noindex
      />
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.message')}</p>
      <p>
        <Link to={getLocalizedPath('/store', locale)}>{t('notFound.store')}</Link>
      </p>
    </main>
  );
};

export default NotFoundPage;
